import React, { useContext, useEffect, useState } from 'react'
import { ERROR_MESSAGES } from '../../Components/GlobalErrorMessage';
import dayjs from 'dayjs';
import { t } from 'i18next';
import DatePicker from "react-date-picker";
import "react-calendar/dist/Calendar.css";
import "react-date-picker/dist/DatePicker.css";
import { LoaderContext } from '../../AuthContext/AuthContext';
import { useLocation, useNavigate } from 'react-router-dom';
import { GetProfileDetails, GetUserModel } from '../../ApiServices/Profile/ProfileApi';
import axios from 'axios';
import { handleProceedRemainingPayment } from '../../Components/RazorPay/RazorPayFunction';
import { BaseUrl } from '../../BaseUrl/BaseUrl';
import toast from 'react-hot-toast';
import CODModal from '../PanditBooking/CODModal';
import { PujaBooking } from '../../ApiServices/Puja/PujaApi';
import { GetUserWalletAmount } from '../../ApiServices/UserWallet/UserWalletApi';
import Select from "react-select";
import { customSelectStyles, DurationLookupList } from '../../middlewares/Utils';
import { GetAppLanguageLookupList, LanguageList } from '../../ApiServices/DailyPanditAPI/DailyPanditApi';
import { FaqModuleID, PaymentTypeID } from '../../Components/enum';
import CouponModal from '../../Components/CouponModal';
import { CityLookupList, GetDistrictLookupList, GetStateLookupList, StateLookupList } from '../../ApiServices/Other/StateLookupListApi';
import { GetDurationDays, GetDurationDaysModel } from '../../ApiServices/Other/DurationDaysApi';
import useApplyCouponCode from "../../Components/SingleCoupon";

const PujaBookingFormSection = () => {
    const userID = localStorage.getItem("userID");
    const userKeyID = localStorage.getItem("userKeyID");
    const location = useLocation()
    const navigate = useNavigate()
    const { setLoader, formatToIndianCurrency, pujaStatus, selectedLanguageID, isLanguageUpdate } = useContext(LoaderContext);

    const pujaDetails = location?.state?.pujaDetailsData;
    const [grandTotal, setGrandTotal] = useState(0)
    const [step, setStep] = useState(1);
    const [error, setError] = useState(false)
    const [showCODModal, setShowCODModal] = useState(null);


    const [availableWalletAmount, setAvailableWalletAmount] = useState(0)
    const [appliedCoupon, setAppliedCoupon] = useState({
        couponCode: null,
        isApplied: false,
        couponAmount: 0,
        walletAmount: 0,
        couponCodeID: null
    });
    const [isWalletApplied, setIsWalletApplied] = useState(false);
    const [isCouponApplied, setIsCouponApplied] = useState(false);

    const [modelRequestData, setModelRequestData] = useState({
        totalPrice: null,
        amountEntered: null,
        moduleName: null,
        couponCode: null
    });
    const [bookingFormData, setBookingData] = useState({
        fullName: null, gotra: null, birthDate: null, birthTime: null, birthPlace: null,
        durationID: null, pujaEndTime: null, pujaEndDate: null, pujaStartTime: null, pujaStartDate: null, days: null,
        address: null, stateID: null, districtID: null, whatsappNumber: null, remark: null, isWetSamagriNeeded: true, isDrySamagriNeeded: pujaDetails?.drySamagriPrice == 0 ? false : true,
        pujaType: 2, date: null, pinCode: null, languageID: null, isPhysicallyAttend: false
    })

    const [bookingDetails, setBookingDetails] = useState(null)
    const [couponAmount, setCouponAmount] = useState(0)
    // -----------------------pandit booking parameters 

    const [daysList, setDaysList] = useState([]);
    const [languageOption, setLanguageOption] = useState([]);
    const [stateLookupList, setStateLookupList] = useState([]);
    const [cityLookupList, setCityLookupList] = useState([]);
    const [pujaTypeLookupList, setPujaTypeLookupList] = useState([{ value: 1, label: 'No' }, { value: 2, label: 'Yes' }]);
    const [showCouponModal, setShowCouponsModal] = useState(false)
    const [durationList, setDurationList] = useState(DurationLookupList);
    const [isGotraKnow, setsGotraKnown] = useState(false)
    const [selectedDays, setSelectedDays] = useState(null);
    const [couponCodeInput, setCouponCodeInput] = useState("");
    const [couponMessage, setCouponMessage] = useState("");
    const [couponMessageVisible, setCouponMessageVisible] = useState(false);

    const [canCalculateDays, setCalculationDays] = useState(false);
    const [couponObj, setCouponObj] = useState({
        userKeyID: userKeyID,
        pujaServiceID: null,
        pujaSubServiceID: null,
        orderAmount: 0

    })
    const {
        applyCoupon,
        isApplying,
    } = useApplyCouponCode({
        apiParam: couponObj,
        setIsCouponApplied,
        setAppliedCoupon,
        setIsWalletApplied,
    });
    // -----------------------------------
    useEffect(() => {
        const totalConvenienceFee = Math.round(Math.round(Number(pujaDetails?.convenienceFee)) +
            Math.round(Number(pujaDetails?.convinienceFeeTaxAmount) || 0))

        const pujaPrice = Math.round(pujaDetails.offlinePujaPrice - (pujaDetails.offlinePujaDiscountAmount || 0))

        if (pujaDetails?.pujaTypeID === 3) {
            setBookingData((prev) => ({
                ...prev,
                pujaType: 1,

            }));
        }

        setGrandTotal(Math.round(totalConvenienceFee) + pujaPrice)
        if (pujaDetails?.pujaSubServiceID !== 5 && pujaDetails?.pujaSubServiceID !== 6) {

            GetUserModelData()
        } else if ((pujaDetails?.pujaSubServiceID === 5 && pujaDetails?.pujaTypeID === 1)) {
            setBookingData((prev) => ({ ...prev, pujaType: 1 }))
        }
        setBookingDetails(location?.state?.pujaDetailsData)
        GetUserWalletAmountData()
        GetLanguageListLookupListData()
        GetStateLookupListData()
    }, [])

    useEffect(() => {
        if (isLanguageUpdate) {
            GetStateLookupListData()
            GetLanguageListLookupListData()
            if (bookingFormData?.stateID !== null && bookingFormData?.stateID !== undefined) {
                GetDistrictLookupListData(bookingFormData?.stateID)

            }

        }
    }, [isLanguageUpdate])

    useEffect(() => {

        if (isWalletApplied && isCouponApplied === false) {

            const pujaPrice = Math.round(pujaDetails.offlinePujaPrice - (pujaDetails.offlinePujaDiscountAmount || 0))
            const minAmount = Math.min(pujaPrice, availableWalletAmount);
            const discountAmount = Math.round(minAmount * 0.5);
            setAppliedCoupon((prev) => ({ ...prev, walletAmount: discountAmount }))
            setCouponAmount(discountAmount);


            // setCouponAmount(walletAmount)
        } else if (isWalletApplied === false && isCouponApplied === true) {
            setCouponAmount(appliedCoupon?.couponAmount)
        } else {
            setCouponAmount(0)
        }
    }, [isWalletApplied, isCouponApplied])

    useEffect(() => {
        let calculatedDays = 0;

        if (bookingFormData?.durationID === 1) {
            calculatedDays = selectedDays * 7;
        } else if (bookingFormData?.durationID === 2) {
            calculatedDays = selectedDays * 30;
        }

        if (calculatedDays > 0 && bookingFormData?.pujaStartDate) {
            const pujaStartDate = new Date(bookingFormData.pujaStartDate); // Ensure it's a Date object
            if (!isNaN(pujaStartDate)) {
                // Check if the conversion was successful
                const newEndDate = new Date(pujaStartDate);
                newEndDate.setDate(pujaStartDate.getDate() + calculatedDays - 1);

                setBookingData((prev) => ({
                    ...prev,
                    pujaEndDate: newEndDate.toISOString().split("T")[0], // Format as YYYY-MM-DD if needed
                    days: calculatedDays
                }));
            } else {
                console.error("Invalid pujaStartDate:", bookingFormData.pujaStartDate);
            }
        }
    }, [selectedDays, bookingFormData?.pujaStartDate]);


    useEffect(() => {
        TotalCalculations()
    }, [couponAmount, bookingFormData])

    useEffect(() => {
        if (
            bookingFormData?.durationID !== null &&
            bookingFormData?.durationID !== undefined &&
            bookingFormData?.durationID !== ""
        ) {

            GetDaysLookupListData();
        }
    }, [bookingFormData?.durationID]);


    const TotalCalculations = () => {

        if (bookingDetails?.pujaSubServiceID !== 6) {
            let pujaPrice = Math.round(pujaDetails.offlinePujaPrice - (pujaDetails.offlinePujaDiscountAmount || 0))
            if (bookingFormData?.pujaType === 1) {
                pujaPrice = Math.round(pujaDetails.onlinePujaPrice - (pujaDetails.onlinePujaDiscountAmount || 0))
            }


            const totalConvenienceFee = Math.round(Math.round(Number(pujaDetails?.convenienceFee)) +
                Math.round(Number(pujaDetails?.convinienceFeeTaxAmount) || 0))

            const totalDryAmount = Math.round(Math.round(Number(pujaDetails?.drySamagriPrice)) +
                Math.round(Number(pujaDetails?.drySamagriPriceTaxAmount) || 0))

            const totalWetAmount = Math.round(Math.round(Number(pujaDetails?.wetSamagriPrice)) +
                Math.round(Number(pujaDetails?.wetSamagriPriceTaxAmount) || 0))

            if (bookingFormData?.isWetSamagriNeeded && bookingFormData?.isDrySamagriNeeded) {
                setGrandTotal(Math.round(totalConvenienceFee) + pujaPrice + Math.round(totalWetAmount) + Math.round(totalDryAmount) - couponAmount)
            } else if (bookingFormData?.isWetSamagriNeeded && bookingFormData?.isDrySamagriNeeded === false) {
                setGrandTotal(Math.round(totalConvenienceFee) + pujaPrice + Math.round(totalWetAmount) - couponAmount)
            } else if (bookingFormData?.isWetSamagriNeeded === false && bookingFormData?.isDrySamagriNeeded) {
                setGrandTotal(Math.round(totalConvenienceFee) + pujaPrice + Math.round(totalDryAmount) - couponAmount)
            } else if (Number(pujaPrice) > couponAmount) {
                setGrandTotal(Math.round(totalConvenienceFee) + pujaPrice - couponAmount)
            }
        } else {

            const days = bookingFormData?.days || 0;

            // ---- Puja Price ----
            let pujaPrice = Math.round(
                (pujaDetails.offlinePujaPrice - pujaDetails.offlinePujaDiscountAmount) * days
            );
            if (bookingFormData?.pujaType === 1) {
                pujaPrice = Math.round(
                    (pujaDetails.onlinePujaPrice - pujaDetails.onlinePujaDiscountAmount) * days
                );
            }

            // ---- Convenience Fee ----
            const totalConvenienceFee = Math.round(
                (Number(pujaDetails?.convenienceFee) + Number(pujaDetails?.convinienceFeeTaxAmount)) * days
            );

            // ---- Dry Samagri ----
            const totalDryAmount = Math.round(
                (Number(pujaDetails?.drySamagriPrice) + Number(pujaDetails?.drySamagriPriceTaxAmount)) * days
            );

            // ---- Fresh Samagri ----
            const totalWetAmount = Math.round(
                (Number(pujaDetails?.wetSamagriPrice) + Number(pujaDetails?.wetSamagriPriceTaxAmount)) * days
            );
            let total = 0;

            if (bookingFormData?.isWetSamagriNeeded && bookingFormData?.isDrySamagriNeeded) {
                total = (Math.round((totalConvenienceFee) + pujaPrice + Math.round(totalWetAmount) + Math.round(totalDryAmount) - couponAmount))

            } else if (bookingFormData?.isWetSamagriNeeded && bookingFormData?.isDrySamagriNeeded === false) {
                total = (Math.round(((totalConvenienceFee) + pujaPrice + Math.round(totalWetAmount) - couponAmount)))

            } else if (bookingFormData?.isWetSamagriNeeded === false && bookingFormData?.isDrySamagriNeeded) {
                total = (Math.round(((totalConvenienceFee) + pujaPrice + Math.round(totalDryAmount) - couponAmount)))

            } else if (Number(pujaPrice) > couponAmount) {
                total = (Math.round(((totalConvenienceFee) + pujaPrice - couponAmount)))

            }
            total = (total)

            setGrandTotal(total)
        }





    }

    const GetDaysLookupListData = async () => {
        try {
            const response = await GetDurationDaysModel(bookingFormData?.durationID); // Ensure it's correctly imported
            // const response = selectedDuration === 1 ? WeekDays : MonthDays

            if (response?.statusCode === 200) {
                const languageLookupList = response?.responseData?.data || [];

                const formattedLangList = languageLookupList.map((Lang) => ({
                    value: Lang.days,
                    label: Lang.days,
                    totalDays: Lang.totalDays,
                }));
                setDaysList(formattedLangList);

            } else {
                console.error(
                    "Failed to fetch sim Type lookup list:",
                    response?.data?.statusMessage || "Unknown error"
                );
            }
        } catch (error) {
            console.error("Error fetching sim Type lookup list:", error);
        }
    };

    const GetStateLookupListData = async () => {
        try {
            const response = await GetStateLookupList(Number(selectedLanguageID)); // Ensure it's correctly imported

            if (response?.statusCode === 200) {
                const languageLookupList = response?.responseData?.data || [];

                const formattedLangList = languageLookupList.map((Lang) => ({
                    value: Lang.stateID,
                    label: Lang.stateName,
                }));

                setStateLookupList(formattedLangList);
            } else {
                console.error(
                    "Failed to fetch sim Type lookup list:",
                    response?.data?.statusMessage || "Unknown error"
                );
            }
        } catch (error) {
            console.error("Error fetching sim Type lookup list:", error);
        }
    };
    const GetDistrictLookupListData = async (ID) => {

        try {
            const response = await GetDistrictLookupList(ID, Number(selectedLanguageID));

            if (response?.statusCode === 200) {

                const languageLookupList = response?.responseData?.data || [];

                const formattedLangList = languageLookupList.map((Lang) => ({
                    value: Lang.districtID,
                    label: Lang.districtName,
                }));

                setCityLookupList(formattedLangList);
            } else {

                console.error(
                    "Failed to fetch sim Type lookup list:",
                    response?.data?.statusMessage || "Unknown error"
                );
            }
        } catch (error) {
            setLoader(false);
            console.error("Error fetching sim Type lookup list:", error);
        }
    };

    const GetLanguageListLookupListData = async () => {
        setLoader(true);
        try {
            const response = await GetAppLanguageLookupList(Number(selectedLanguageID)); // Ensure it's correctly imported

            if (response?.statusCode === 200) {
                setLoader(false);

                const languageLookupList = response?.responseData?.data || [];
                const formattedLangList = languageLookupList.map((Lang) => ({
                    value: Lang.appLangID,
                    label: Lang.languageName,
                }));

                setLanguageOption(formattedLangList);
            } else {
                setLoader(false);
                console.error(
                    "Failed to fetch sim Type lookup list:",
                    response?.data?.statusMessage || "Unknown error"
                );
            }
        } catch (error) {
            setLoader(false);
            console.error("Error fetching sim Type lookup list:", error);
        }
    };

    const GetUserModelData = async () => {

        try {
            const response = await GetProfileDetails(userKeyID);
            if (response?.statusCode === 200) {
                const ModelData = response?.responseData?.data || []; // Assuming the data is an array and we need the first item

                setBookingData((prev) => ({
                    ...prev,
                    birthDate: ModelData?.dob,
                    birthPlace: ModelData?.birthPlace,
                    birthTime: ModelData?.tob,
                    time24: ModelData?.tob,
                    fullName: ModelData?.userName,

                }));
            } else {
                // setLoader(false);

                console.error(
                    "Error fetching data: ",
                    response?.data?.data?.statusCode
                );
            }
        } catch (error) {
            // setLoader(false);

            console.error("Error", error);
        }
    };

    const GetUserWalletAmountData = async () => {

        setLoader(true);
        try {
            let response = await GetUserWalletAmount(userKeyID); // Replace with actual import/function call
            if (response?.statusCode === 200) {
                setLoader(false);

                const list = response?.responseData?.data
                setAvailableWalletAmount(Number(list) <= 0 ? 0 : list)

            } else {
                console.error("Bad request");
                setLoader(false);
            }
        } catch (error) {
            console.log(error);
            setLoader(false);
        }
    };




    // ----------------------------------------------------------

    const nextStep = () => {
        if (step < 3) setStep(step + 1);
    };

    const prevStep = () => {
        if (step > 1) setStep(step - 1);
    };

    const handleChange = (e) => {

        let { id, value } = e.target;
        if (id === "gotra" || id === "birthPlace") {
            // Prevent first space but allow later spaces
            value = value.replace(/^\s+/, '');

            value = value.charAt(0).toUpperCase() + value.slice(1);
        }
        if (id === "fullName") {
            // Prevent first space but allow later spaces
            value = value.replace(/^\s+/, '');

            value = value.replace(/[^a-zA-Z\s]/g, '');
            value = value.charAt(0).toUpperCase() + value.slice(1);

        }



        setBookingData((prev) => ({
            ...prev,
            [id]: value,
        }));
    };

    const handleBirthDateChange = (newValue) => {
        if (dayjs(newValue).isValid()) {
            const newToDate = dayjs(newValue).format("YYYY-MM-DD");
            setBookingData((prev) => ({ ...prev, birthDate: newToDate }));
        }
    };


    const handleValidation = () => {

        let isValid = true
        if ((pujaDetails?.pujaSubServiceID !== 5 && pujaDetails?.pujaSubServiceID !== 6 && pujaDetails?.pujaCategoryName !== "Deepdan") && (bookingFormData?.fullName === null || bookingFormData?.fullName === undefined || bookingFormData?.fullName === "" ||
            bookingFormData?.gotra === null || bookingFormData?.gotra === undefined || bookingFormData?.gotra === "" ||
            bookingFormData?.birthPlace === null || bookingFormData?.birthPlace === undefined || bookingFormData?.birthPlace === "" ||
            bookingFormData?.birthDate === null || bookingFormData?.birthDate === undefined || bookingFormData?.birthDate === "" ||
            bookingFormData?.birthTime === null || bookingFormData?.birthTime === undefined || bookingFormData?.birthTime === "")

        ) {
            isValid = false;
            setError(true)
            return isValid
        } else if ((pujaDetails?.pujaSubServiceID === 5 && (bookingDetails?.pujaTypeID !== 1) && pujaDetails?.pujaCategoryName !== "Deepdan") && (bookingFormData?.pujaStartDate === null || bookingFormData?.pujaStartDate === undefined || bookingFormData?.pujaStartDate === "" ||
            bookingFormData?.stateID === null || bookingFormData?.stateID === undefined || bookingFormData?.stateID === "" ||
            bookingFormData?.districtID === null || bookingFormData?.districtID === undefined || bookingFormData?.districtID === "" ||
            bookingFormData?.address === null || bookingFormData?.address === undefined || bookingFormData?.address === "")) {
            isValid = false;
            setError(true)
            return isValid

        } else if ((pujaDetails?.pujaSubServiceID === 5 && (bookingDetails?.pujaTypeID === 1) && pujaDetails?.pujaCategoryName !== "Deepdan") && (bookingFormData?.pujaStartDate === null || bookingFormData?.pujaStartDate === undefined || bookingFormData?.pujaStartDate === "" ||
            bookingFormData?.gotra === null || bookingFormData?.gotra === undefined || bookingFormData?.gotra === "" ||
            bookingFormData?.fullName === null || bookingFormData?.fullName === undefined || bookingFormData?.fullName === "" ||
            bookingFormData?.address === null || bookingFormData?.address === undefined || bookingFormData?.address === "" ||
            bookingFormData?.languageID === null || bookingFormData?.languageID === undefined || bookingFormData?.languageID === "")) {
            isValid = false;
            setError(true)
            return isValid

        } else if (pujaDetails?.pujaSubServiceID === 6 && pujaDetails?.pujaCategoryName !== "Deepdan" && (bookingFormData?.pujaStartDate === null || bookingFormData?.pujaStartDate === undefined || bookingFormData?.pujaStartDate === "" ||
            bookingFormData?.pujaEndDate === null || bookingFormData?.pujaEndDate === undefined || bookingFormData?.pujaEndDate === "" ||
            bookingFormData?.pujaStartTime === null || bookingFormData?.pujaStartTime === undefined || bookingFormData?.pujaStartTime === "" ||
            // bookingFormData?.pujaEndTime === null || bookingFormData?.pujaEndTime === undefined || bookingFormData?.pujaEndTime === "" ||
            bookingFormData?.days === null || bookingFormData?.days === undefined || bookingFormData?.days === "" ||
            bookingFormData?.durationID === null || bookingFormData?.durationID === undefined || bookingFormData?.durationID === "" ||
            bookingFormData?.languageID === null || bookingFormData?.languageID === undefined || bookingFormData?.languageID === "" ||
            bookingFormData?.stateID === null || bookingFormData?.stateID === undefined || bookingFormData?.stateID === "" ||
            bookingFormData?.districtID === null || bookingFormData?.districtID === undefined || bookingFormData?.districtID === "" ||
            bookingFormData?.address === null || bookingFormData?.address === undefined || bookingFormData?.address === "")) {
            isValid = false;
            setError(true)
            return isValid
        } else if (pujaDetails?.pujaCategoryName === "Deepdan" && (bookingFormData?.whatsappNumber === null || bookingFormData?.whatsappNumber === undefined || bookingFormData?.whatsappNumber === "" || bookingFormData?.whatsappNumber?.length < 10 || bookingFormData?.remark === null || bookingFormData?.remark === undefined || bookingFormData?.remark === "" || bookingFormData?.pujaStartDate === null || bookingFormData?.pujaStartDate === undefined || bookingFormData?.pujaStartDate === "")) {
            isValid = false;
            setError(true)
            return isValid
        } else {
            return isValid
        }

    }

    const handleRazorpayPayment = async () => {

        const isValid = handleValidation()
        if (isValid) {
            let orderIDReturned = null
            let minPayableAmount = modelRequestData.amountEntered
                ? modelRequestData.amountEntered
                : Math.round(grandTotal);
            setLoader(true)
            const PlaceOrderResponse = await handleProceedRemainingPayment(minPayableAmount)


            if (PlaceOrderResponse?.status === 1) {

                try {
                    const response = await PujaBooking({
                        pujaServiceID: bookingDetails?.pujaServiceID,
                        pujaSubServiceID: bookingDetails?.pujaSubServiceID,
                        userKeyID: userKeyID,
                        pujaKeyID: bookingDetails?.pujaKeyID,
                        pujaPrice: bookingFormData?.pujaType === 1 ? bookingDetails?.onlinePujaPrice : bookingDetails?.offlinePujaPrice,
                        pujaTypeID: bookingFormData?.pujaType,
                        wetSamagriPrice: bookingDetails?.wetSamagriPrice,
                        drySamagriPrice: bookingDetails?.drySamagriPrice,
                        convenienceFee: bookingDetails?.convenienceFee,
                        appLangID: bookingDetails?.appLangID,
                        discountPercentage: bookingDetails?.pujaDiscount,
                        taxPercentage: bookingDetails?.taxPercentage,
                        convinienceFeeTaxPercent: bookingDetails?.convinienceFeeTaxPercent,
                        wetSamagriPriceTaxPercent: bookingDetails?.wetSamagriPriceTaxPercent,
                        drySamagriPriceTaxPercent: bookingDetails?.drySamagriPriceTaxPercent,
                        pujaTime: bookingDetails?.pujaTime,
                        pujaDate: bookingDetails?.pujaDate,
                        title: bookingDetails?.title,
                        subTitle: bookingDetails?.subTitle,
                        timeLine: bookingDetails?.timeLine,
                        description: bookingDetails?.description,
                        tempPujaSubPackageKeyID: bookingDetails?.tempPujaSubPackageKeyID,

                        appLangID: bookingFormData?.languageID,
                        pujaStartDate: bookingFormData?.pujaStartDate,
                        pujaStartTime: bookingFormData?.pujaStartTime,
                        pujaEndDate: bookingFormData?.pujaEndDate,
                        pujaEndTime: bookingFormData?.pujaEndTime,
                        durationID: bookingFormData?.durationID,
                        days: bookingFormData?.days,
                        customerName: bookingFormData?.fullName,
                        gotra: bookingFormData?.gotra,
                        dateOfBirth: bookingFormData?.birthDate,
                        dateOfTime: bookingFormData?.birthTime,
                        birthPlace: bookingFormData?.birthPlace,
                        address: bookingFormData?.address,
                        stateID: bookingFormData?.stateID,
                        districtID: bookingFormData?.districtID,
                        whatsappNumber: bookingFormData?.whatsappNumber,
                        remark: bookingFormData?.remark,
                        isWetSamagriNeeded: bookingFormData?.isWetSamagriNeeded,
                        isDrySamagriNeeded: bookingFormData?.isDrySamagriNeeded,
                        paymentStatus: minPayableAmount === grandTotal ? true : false,
                        paymentTypeID: modelRequestData.amountEntered ? 1 : 2,
                        isPhysicallyAttend: bookingFormData?.isPhysicallyAttend,
                        transactionAmount: minPayableAmount,
                        transactionID: PlaceOrderResponse?.razorpay_payment_id,
                        couponCodeID: appliedCoupon?.couponCodeID,
                        couponCodeAmount: appliedCoupon?.couponAmount,
                        walletAmount: appliedCoupon?.walletAmount,
                        applicationType: "Website",

                    });

                    if (response?.statusCode === 200) {
                        setLoader(false);
                        setShowCODModal(false);
                        let moduleName = null
                        if (bookingDetails?.pujaSubServiceID === 1) {
                            moduleName = 'RemedyPuja'
                        } else if (bookingDetails?.pujaSubServiceID === 2) {
                            moduleName = 'HomamPuja'
                        } else if (bookingDetails?.pujaSubServiceID === 5) {
                            moduleName = 'PanditBooking'
                        } else if (bookingDetails?.pujaSubServiceID === 6) {
                            moduleName = 'DailyPanditBooking'
                        } else if (bookingDetails?.pujaSubServiceID === 3) {
                            moduleName = 'SubscriptionRemedyBooking'
                        } else if (bookingDetails?.pujaSubServiceID === 4) {
                            moduleName = 'SubscriptionHomamBooking'
                        } else if (bookingDetails?.pujaSubServiceID === 7) {
                            moduleName = 'PujaAtTemple'
                        }
                        navigate("/thank-you", {
                            state: { moduleName: moduleName },
                        });
                    } else {
                        setLoader(false);
                    }


                } catch (error) {
                    setLoader(false);
                    console.log(error);
                }
            } else if (PlaceOrderResponse?.status === 0) {
                setLoader(false)

            }
        }

    };

    const handleCODClicked = () => {
        const isValid = handleValidation()
        if (isValid) {
            setModelRequestData((prev) => ({
                ...prev,
                totalPrice: grandTotal,
                tax: 18,
                convenienceFee: pujaDetails?.convenienceFee,
                convenienceFeeFax: pujaDetails?.ConvinienceFeeTaxAmount || 0,
                SamagriPriceTaxAmount:
                    pujaDetails?.ConvinienceFeeTaxPercent != 0
                        ? pujaDetails?.SamagriPriceTaxAmount || 0
                        : 0,
                amountEntered: Math.ceil(modelRequestData.totalPrice * 0.2)
            }));
            setShowCODModal(true);
        }

    };


    const handleLanguageChange = (selectedValue) => {
        setBookingData((prev) => ({
            ...prev,
            languageID: selectedValue.value,
        }));
    };

    const handlePujaTypeChange = (selectedValue) => {
        setAppliedCoupon((prev) => ({
            ...prev, couponCode: null,
            isApplied: false,
            couponAmount: 0,
            walletAmount: 0
        }))
        setIsWalletApplied(false)
        setIsCouponApplied(false)
        if (bookingFormData?.pujaType === 2) {
            setBookingData((prev) => ({
                ...prev,
                pujaType: 1,

            }));
        } else {
            setBookingData((prev) => ({
                ...prev,
                pujaType: 2,

            }));
        }
        setBookingData((prev) => ({
            ...prev,
            isPhysicallyAttend: !prev.isPhysicallyAttend,

        }));
    };


    const handleToDateChange = (newValue) => {
        if (dayjs(newValue).isValid()) {
            const newToDate = dayjs(newValue).format("YYYY-MM-DD");
            setBookingData((prev) => ({ ...prev, pujaStartDate: newToDate }));
        } else {
            setBookingData((prev) => ({ ...prev, pujaStartDate: null }));
        }
    };


    const handleOpenCoupenModal = () => {
        setCouponObj((prev) => ({
            ...prev,
            userID: userID,
            pujaServiceID: pujaDetails?.pujaServiceID,
            pujaSubServiceID: pujaDetails?.pujaSubServiceID,
            orderAmount: bookingFormData?.pujaType === 1 ? (Math.round(pujaDetails.onlinePujaPrice - (pujaDetails.onlinePujaDiscountAmount || 0))) : (Math.round(pujaDetails.offlinePujaPrice - (pujaDetails.offlinePujaDiscountAmount || 0)))
        }))
        setModelRequestData((prev) => ({ ...prev, moduleName: 'PujaBooking' }))
        setShowCouponsModal(true)
    }



    const handleStartDateChange = (newValue) => {
        if (dayjs(newValue).isValid()) {
            const newToDate = dayjs(newValue).format("YYYY-MM-DD");
            setBookingData((prev) => ({ ...prev, pujaStartDate: newToDate }));
        } else {
            setBookingData((prev) => ({ ...prev, pujaStartDate: null }));
        }
    };

    const handleEndDateChange = (newValue) => {
        if (dayjs(newValue).isValid()) {
            const newToDate = dayjs(newValue).format("YYYY-MM-DD");
            setBookingData((prev) => ({ ...prev, pujaEndDate: newToDate }));
        } else {
            setBookingData((prev) => ({ ...prev, pujaEndDate: null }));
        }
    };

    const handleDurationChange = (selectedValue) => {
        GetDaysLookupListData()
        setBookingData((prev) => ({ ...prev, durationID: selectedValue.value }));

    };
    const handleDaysChange = (selectedValue) => {
        setSelectedDays(selectedValue.value);
        setBookingData((prev) => ({ ...prev, days: selectedValue?.totalDays }));
        setCalculationDays(true)

    };

    console.log("bookingFormData", location?.state?.pujaDetailsData)
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);


    const days = bookingFormData?.days || 1;
    const isMultiDay = pujaDetails?.pujaSubServiceID === 6;

    // 1️⃣ Base Puja Price
    const pujaBasePrice = bookingFormData?.pujaType === 1
        ? Math.round(pujaDetails?.onlinePujaPrice - (pujaDetails?.onlinePujaDiscountAmount || 0))
        : Math.round(pujaDetails?.offlinePujaPrice - (pujaDetails?.offlinePujaDiscountAmount || 0));

    const finalPujaPrice = isMultiDay ? pujaBasePrice * days : pujaBasePrice;

    // 2️⃣ Samagri Price
    let samagriPrice = 0;

    if (pujaDetails?.pujaCategoryName !== "Deepdan") {


        if (bookingFormData?.isDrySamagriNeeded) {
            samagriPrice += Number(pujaDetails?.drySamagriPrice || 0)
                + Number(pujaDetails?.drySamagriPriceTaxAmount || 0);
        }
        if (bookingFormData?.isWetSamagriNeeded) {
            samagriPrice += Number(pujaDetails?.wetSamagriPrice || 0)
                + Number(pujaDetails?.wetSamagriPriceTaxAmount || 0);
        }

        if (isMultiDay) {
            samagriPrice = samagriPrice * days;
        }
    }

    // 3️⃣ Convenience Fee
    let convenienceFee = 0;

    if (Number(pujaDetails?.convenienceFee) > 0) {
        convenienceFee =
            Math.round(Number(pujaDetails?.convenienceFee)) +
            Math.round(Number(pujaDetails?.convinienceFeeTaxAmount || 0));

        if (isMultiDay) {
            convenienceFee = convenienceFee * days;
        }
    }

    // 4️⃣ FINAL Puja Price (INCLUDING everything)
    let pujaPriceWithAllCharges =
        finalPujaPrice + samagriPrice + convenienceFee;
    useEffect(() => {
        if (pujaDetails?.pujaTypeID === 3 && bookingFormData?.isPhysicallyAttend) {
            pujaPriceWithAllCharges = pujaDetails?.offilePujaPriceWithAllCharges
        } else if (pujaDetails?.pujaTypeID === 3 && bookingFormData?.isPhysicallyAttend === false) {
            pujaPriceWithAllCharges = pujaDetails?.onlinePujaPriceWithAllCharges
        } else {
            pujaPriceWithAllCharges = pujaDetails?.offilePujaPriceWithAllCharges
        }
    }, [pujaDetails])

    console.log("pujaDetails?.paymentTypeID", pujaDetails?.paymentTypeID)

    return (
        <>
            <div className="container my-5" style={{ display: "flex", flexDirection: "column" }}>

                <h4 className='text-center'>{`${pujaDetails?.pujaName} ${location?.state?.pujaDetailsData?.pujaSubServiceID === 2 ? t("Puja Booking Form") : t("Booking Form")
                    }`}
                </h4>
                {/* Step Content */}
                <div className=" p-4 shadow">
                    {step === 1 && (
                        <>
                            <div className="row">
                                {/* Left Side - Booking Form */}
                                <div className="col-md-8 col-sm-12 mb-3">
                                    <fieldset className="border rounded p-3">
                                        <legend className="float-none w-auto px-2 fw-bold" style={{ fontSize: "14px" }}>
                                            {t("Booking Form")}
                                        </legend>
                                        <div className="row justify-content-left" style={{ justifyContent: "left" }}>

                                            {/* Form inputs for other than puja Booking  */}
                                            {(pujaDetails?.pujaSubServiceID !== 5 && pujaDetails?.pujaSubServiceID !== 6) && (
                                                <>
                                                    {/* Full Name */}
                                                    <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size">
                                                        <label htmlFor="fullName" style={{ textAlign: "left" }}>
                                                            {t("Full Name")}<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <input
                                                            id="fullName"
                                                            type="text"
                                                            className="custom-form-control"
                                                            value={bookingFormData.fullName || ""}
                                                            onChange={handleChange}
                                                            placeholder={t("Enter Full Name")}
                                                        />
                                                        {error && !bookingFormData.fullName && (
                                                            <span className="error-msg">{t(ERROR_MESSAGES)}</span>
                                                        )}
                                                    </div>

                                                    {/* Gotra */}
                                                    <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size">
                                                        <label htmlFor="gotra" style={{ textAlign: "left" }}>
                                                            {t("Gotra")}<span style={{ color: "red" }}>*</span>
                                                        </label>

                                                        <input
                                                            id="gotra"
                                                            type="text"
                                                            className="custom-form-control"
                                                            value={bookingFormData.gotra || ""}
                                                            onChange={handleChange}
                                                            placeholder={t("Enter Gotra")}
                                                        />
                                                        {error && !bookingFormData.gotra && (
                                                            <span className="error-msg">{t(ERROR_MESSAGES)}</span>
                                                        )}

                                                        {/* ---- checkbox row ---- */}
                                                        <div className="d-flex align-items-center mt-2">
                                                            <input
                                                                id="checkBox"
                                                                type="checkbox"
                                                                className="me-2"        // margin-end for spacing
                                                                checked={isGotraKnow}
                                                                onChange={() => {
                                                                    if (isGotraKnow) {
                                                                        // if user UNchecks: clear gotra
                                                                        setBookingData(prev => ({ ...prev, gotra: "" }));
                                                                    } else {
                                                                        // if user CHECKS: set default gotra
                                                                        setBookingData(prev => ({ ...prev, gotra: "Kashyap" }));
                                                                    }
                                                                    setsGotraKnown(!isGotraKnow);
                                                                }}
                                                            />


                                                            <label htmlFor="checkBox" className="m-0 text-muted" style={{ fontSize: '10px' }}>
                                                                {t("I don’t know my Gotras")}
                                                            </label>
                                                        </div>
                                                    </div>


                                                    {/* Birth Date */}
                                                    <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size">
                                                        <label htmlFor="birthDate" style={{ textAlign: "left" }}>
                                                            {t("Birth Date")}<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <DatePicker
                                                            id="birthDate"
                                                            value={bookingFormData?.birthDate || null}
                                                            onChange={handleBirthDateChange}
                                                            format="dd/MM/yyyy"
                                                            placeholder="dd/MM/yyyy"
                                                            className="custom-date-picker"
                                                            clearIcon={null}
                                                            maxDate={yesterday}
                                                            dayPlaceholder={t("DD")}
                                                            monthPlaceholder={t("MM")}
                                                            yearPlaceholder={t("YYYY")}
                                                        />
                                                        {/* {error && !bookingFormData.birthDate && (
                                                            <span className="error-msg">{t(ERROR_MESSAGES)}</span>
                                                        )} */}
                                                    </div>

                                                    {/* Birth Time */}
                                                    <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size">
                                                        <label style={{ textAlign: "left" }}>
                                                            {t("Birth Time")}<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <input
                                                            id="birthTime"
                                                            type="time"
                                                            className="custom-form-control"
                                                            value={bookingFormData.time24 || ""}
                                                            onClick={(e) => e.target.showPicker && e.target.showPicker()}
                                                            onChange={(e) => {
                                                                const [hour, minute] = e.target.value.split(":");
                                                                let hr = parseInt(hour, 10);
                                                                const ampm = hr >= 12 ? "PM" : "AM";
                                                                hr = hr % 12 || 12;
                                                                const formattedTime = `${hr}:${minute} ${ampm}`;

                                                                setBookingData((prev) => ({
                                                                    ...prev,
                                                                    birthTime: formattedTime,
                                                                    time24: e.target.value,
                                                                }));
                                                            }}
                                                            placeholderText="Select Birth Time"
                                                        />
                                                        {error && !bookingFormData.birthTime && (
                                                            <span className="error-msg">{t(ERROR_MESSAGES)}</span>
                                                        )}
                                                    </div>

                                                    {/* Birth Place */}
                                                    <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size">
                                                        <label htmlFor="birthPlace" style={{ textAlign: "left" }}>
                                                            {t("Birth Place")}<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <input
                                                            id="birthPlace"
                                                            type="text"
                                                            className="custom-form-control"
                                                            value={bookingFormData.birthPlace || ""}
                                                            onChange={handleChange}
                                                            placeholder={t("Enter Birth Place")}
                                                        />
                                                        {error && !bookingFormData.birthPlace && (
                                                            <span className="error-msg">{t(ERROR_MESSAGES)}</span>
                                                        )}
                                                    </div>

                                                    {/* Select Puja Type */}
                                                    {pujaDetails?.pujaTypeID === 3 && (
                                                        <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column ">
                                                            <div className="d-flex align-items-center mt-4 gap-2">
                                                                <input
                                                                    id="pujaType"
                                                                    type="checkbox"
                                                                    className=" my-auto"   // <-- my-auto vertically centers
                                                                    checked={bookingFormData?.isPhysicallyAttend}
                                                                    onChange={handlePujaTypeChange}
                                                                />
                                                                <label htmlFor="pujaType" className="m-0 ">
                                                                    {t("I want to attend the puja physically.")}
                                                                </label>
                                                            </div>
                                                        </div>

                                                    )}

                                                </>
                                            )}


                                            {/* -------------------Pandit Booking Form---------------------- */}

                                            {(pujaDetails?.pujaSubServiceID === 5) && (pujaDetails?.pujaTypeID !== 1) ? (
                                                <>

                                                    {/*Booking Data*/}
                                                    <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size">
                                                        <label
                                                            htmlFor="bookingDate"
                                                            style={{ textAlign: "left" }}
                                                        >
                                                            {t("Puja Booking Date")}<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <DatePicker
                                                            id="bookingDate"
                                                            value={bookingFormData?.pujaStartDate || ""}
                                                            minDate={
                                                                (pujaStatus === false || pujaStatus === null && pujaDetails?.PoojaTypeID !== 1)
                                                                    ? new Date(new Date().setDate(new Date().getDate() + 3))
                                                                    : new Date(new Date().setDate(new Date().getDate() + 2))
                                                            }
                                                            clearIcon={null}
                                                            onChange={handleToDateChange}
                                                            format="dd/MM/yyyy"
                                                            placeholderText="Select booking date"
                                                            className="custom-date-picker"
                                                            dayPlaceholder="DD"
                                                            monthPlaceholder="MM"
                                                            yearPlaceholder="YYYY"
                                                        />

                                                        {error && !bookingFormData.pujaStartDate && (
                                                            <span className="error-msg">{t(ERROR_MESSAGES)}</span>
                                                        )}
                                                    </div>

                                                    {/* Booking Time */}
                                                    <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size">
                                                        <label

                                                            style={{ textAlign: "left" }}
                                                        >
                                                            {t("Time")}<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <input
                                                            id="bookingTime"
                                                            type="time"
                                                            className="custom-form-control"
                                                            value={bookingFormData.time24 || ""}
                                                            onClick={(e) =>
                                                                e.target.showPicker && e.target.showPicker()
                                                            }
                                                            onChange={(e) => {
                                                                const [hour, minute] = e.target.value.split(":");
                                                                let hr = parseInt(hour, 10);
                                                                const ampm = hr >= 12 ? "PM" : "AM";
                                                                hr = hr % 12 || 12; // convert hoga yaha pr -> 13 ka -> 1
                                                                const formattedTime = `${hr}:${minute} ${ampm}`;

                                                                setBookingData((prev) => ({
                                                                    ...prev,
                                                                    pujaStartTime: formattedTime,
                                                                    time24: e.target.value,
                                                                }));
                                                            }}
                                                        />
                                                        {error && !bookingFormData.pujaStartTime && (
                                                            <span className="error-msg">{t(ERROR_MESSAGES)}</span>
                                                        )}
                                                    </div>

                                                    {/* Select Language */}
                                                    <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size">
                                                        <label htmlFor="language" style={{ textAlign: "left" }}>
                                                            {t("Select Language")}<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <Select

                                                            options={languageOption}
                                                            onChange={handleLanguageChange}
                                                            value={languageOption.find(
                                                                (item) => item.value === bookingFormData.languageID
                                                            )}
                                                            styles={customSelectStyles}
                                                        />

                                                        {error && !bookingFormData.languageID && (
                                                            <span className="error-msg">{t(ERROR_MESSAGES)}</span>
                                                        )}
                                                    </div>

                                                    {/* State */}
                                                    <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size">
                                                        <label htmlFor="state" style={{ textAlign: "left" }}>
                                                            {t("State")}<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <Select

                                                            options={stateLookupList}
                                                            value={stateLookupList.find(
                                                                (item) => item.value === bookingFormData.stateID
                                                            )}
                                                            onChange={(selectedOption) => {
                                                                setBookingData((prev) => ({
                                                                    ...prev,
                                                                    stateID: selectedOption?.value,
                                                                }));
                                                                GetDistrictLookupListData(selectedOption?.value)
                                                            }}
                                                            styles={customSelectStyles}
                                                        />
                                                        {error && !bookingFormData.stateID && (
                                                            <span className="error-msg">{t(ERROR_MESSAGES)}</span>
                                                        )}
                                                    </div>

                                                    {/* City */}
                                                    <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size">
                                                        <label htmlFor="City" style={{ textAlign: "left" }}>
                                                            {t("City")}<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <Select

                                                            options={cityLookupList}
                                                            value={cityLookupList.find(
                                                                (item) => item.value === bookingFormData.districtID
                                                            )}
                                                            onChange={(selectedOption) => {
                                                                setBookingData((prev) => ({
                                                                    ...prev,
                                                                    districtID: selectedOption?.value,
                                                                }));
                                                            }}
                                                            styles={customSelectStyles}
                                                        />
                                                        {error && !bookingFormData.districtID && (
                                                            <span className="error-msg">{t(ERROR_MESSAGES)}</span>
                                                        )}
                                                    </div>{" "}




                                                    {/* Address */}
                                                    <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size">
                                                        <label htmlFor="address" style={{ textAlign: "left" }}>
                                                            {t("Address")}<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <textarea
                                                            id="address"
                                                            className="custom-form-control"
                                                            value={bookingFormData.address || ""}
                                                            onChange={(e) => {
                                                                let inputVal = e.target.value.trimStart();
                                                                setBookingData((prev) => ({
                                                                    ...prev,
                                                                    address: inputVal,
                                                                }));
                                                            }}
                                                            placeholder={t("Enter Address")}
                                                        />
                                                        {error && !bookingFormData.address && (
                                                            <span className="error-msg">{t(ERROR_MESSAGES)}</span>
                                                        )}
                                                    </div>









                                                </>
                                            ) : ((pujaDetails?.pujaSubServiceID === 5) && (pujaDetails?.pujaTypeID === 1)) ? (
                                                <>

                                                    {pujaDetails?.pujaCategoryName === "Deepdan" ? (
                                                        <>
                                                            <div className="row">
                                                                {/* Data */}
                                                                <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size">
                                                                    <label
                                                                        htmlFor="bookingDate"
                                                                        style={{ textAlign: "left" }}
                                                                    >
                                                                        {t("Date")}<span style={{ color: "red" }}>*</span>
                                                                    </label>
                                                                    <DatePicker
                                                                        id="bookingDate"
                                                                        value={bookingFormData?.pujaStartDate || ""}
                                                                        minDate={
                                                                            (pujaStatus === false || pujaStatus === null && pujaDetails?.PoojaTypeID !== 1)
                                                                                ? new Date(new Date().setDate(new Date().getDate() + 3))
                                                                                : new Date(new Date().setDate(new Date().getDate() + 2))
                                                                        }
                                                                        clearIcon={null}
                                                                        onChange={handleToDateChange}
                                                                        format="dd/MM/yyyy"
                                                                        className="custom-date-picker"
                                                                        dayPlaceholder="DD"
                                                                        monthPlaceholder="MM"
                                                                        yearPlaceholder="YYYY"
                                                                    />

                                                                    {error && !bookingFormData.pujaStartDate && (
                                                                        <span className="error-msg">{t(ERROR_MESSAGES)}</span>
                                                                    )}
                                                                </div>


                                                                {/* Whatsapp Number */}
                                                                <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size">
                                                                    <label htmlFor="pinCode" style={{ textAlign: "left" }}>
                                                                        {t("Whatsapp Number")}<span style={{ color: "red" }}>*</span>
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control rounded-3"
                                                                        maxLength={10}
                                                                        placeholder={t("Enter whatsapp number")}
                                                                        value={bookingFormData.whatsappNumber}
                                                                        onChange={(e) => {

                                                                            let formattedNumber = e.target.value.replace(
                                                                                /[^0-9]/g,
                                                                                ""
                                                                            );
                                                                            formattedNumber = formattedNumber.replace(
                                                                                /^[0-5]/,
                                                                                ""
                                                                            );
                                                                            setBookingData((prev) => ({
                                                                                ...prev,
                                                                                whatsappNumber: formattedNumber,
                                                                            }));
                                                                        }}
                                                                    />
                                                                    {error &&
                                                                        (bookingFormData.whatsappNumber === null ||
                                                                            bookingFormData.whatsappNumber === undefined ||
                                                                            bookingFormData.whatsappNumber === "" ? (
                                                                            <span className="text-danger">
                                                                                {t("This field is required")}
                                                                            </span>
                                                                        ) : bookingFormData.whatsappNumber?.length < 10 ? (
                                                                            <span className="text-danger">{t("Invalid number")}</span>
                                                                        ) : (
                                                                            ""
                                                                        ))}
                                                                </div>
                                                            </div>

                                                            {/* {Deepdan Note} */}
                                                            <div className="row">
                                                                <div className="col-md-12 col-sm-12 mb-2 d-flex flex-column form-font-size">
                                                                    <label htmlFor="address" style={{ textAlign: "left" }}>
                                                                        {t("Deepdan Note")}<span style={{ color: "red" }}>*</span>
                                                                    </label>
                                                                    <textarea
                                                                        id="address"
                                                                        maxLength={100}
                                                                        className="custom-form-control"
                                                                        value={bookingFormData.remark || ""}
                                                                        onChange={(e) => {
                                                                            let inputVal = e.target.value.trimStart();
                                                                            setBookingData((prev) => ({
                                                                                ...prev,
                                                                                remark: inputVal,
                                                                            }));
                                                                        }}
                                                                        placeholder={t("Enter Deepdan Note")}
                                                                    />
                                                                    {error && !bookingFormData.remark && (
                                                                        <span className="error-msg">{t(ERROR_MESSAGES)}</span>
                                                                    )}
                                                                </div>


                                                            </div>
                                                        </>
                                                    ) : (
                                                        <>
                                                            {/* Full Name */}
                                                            <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size">
                                                                <label htmlFor="fullName" style={{ textAlign: "left" }}>
                                                                    {t("Full Name")}<span style={{ color: "red" }}>*</span>
                                                                </label>
                                                                <input
                                                                    id="fullName"
                                                                    type="text"
                                                                    className="custom-form-control"
                                                                    value={bookingFormData.fullName || ""}
                                                                    onChange={handleChange}
                                                                    placeholder={t("Enter Full Name")}
                                                                />
                                                                {error && !bookingFormData.fullName && (
                                                                    <span className="error-msg">{t(ERROR_MESSAGES)}</span>
                                                                )}
                                                            </div>

                                                            {/* Gotra */}
                                                            <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size">
                                                                <label htmlFor="gotra" style={{ textAlign: "left" }}>
                                                                    {t("Gotra")}<span style={{ color: "red" }}>*</span>
                                                                </label>

                                                                <input
                                                                    id="gotra"
                                                                    type="text"
                                                                    className="custom-form-control"
                                                                    value={bookingFormData.gotra || ""}
                                                                    onChange={handleChange}
                                                                    placeholder={t("Enter Gotra")}
                                                                />
                                                                {error && !bookingFormData.gotra && (
                                                                    <span className="error-msg">{t(ERROR_MESSAGES)}</span>
                                                                )}

                                                                {/* ---- checkbox row ---- */}
                                                                <div className="d-flex align-items-center mt-2">
                                                                    <input
                                                                        id="checkBox"
                                                                        type="checkbox"
                                                                        className="me-2"        // margin-end for spacing
                                                                        checked={isGotraKnow}
                                                                        onChange={() => {
                                                                            if (isGotraKnow) {
                                                                                // if user UNchecks: clear gotra
                                                                                setBookingData(prev => ({ ...prev, gotra: "" }));
                                                                            } else {
                                                                                // if user CHECKS: set default gotra
                                                                                setBookingData(prev => ({ ...prev, gotra: "Kashyap" }));
                                                                            }
                                                                            setsGotraKnown(!isGotraKnow);
                                                                        }}
                                                                    />


                                                                    <label htmlFor="checkBox" className="m-0 text-muted" style={{ fontSize: '10px' }}>
                                                                        I don’t know my Gotras
                                                                    </label>
                                                                </div>
                                                            </div>

                                                            {/*Booking Data*/}
                                                            <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size">
                                                                <label
                                                                    htmlFor="bookingDate"
                                                                    style={{ textAlign: "left" }}
                                                                >
                                                                    {t("Booking Date")}<span style={{ color: "red" }}>*</span>
                                                                </label>
                                                                <DatePicker
                                                                    id="bookingDate"
                                                                    value={bookingFormData?.pujaStartDate || ""}
                                                                    minDate={
                                                                        (pujaStatus === false || pujaStatus === null && pujaDetails?.PoojaTypeID !== 1)
                                                                            ? new Date(new Date().setDate(new Date().getDate() + 3))
                                                                            : new Date(new Date().setDate(new Date().getDate() + 2))
                                                                    }
                                                                    clearIcon={null}
                                                                    onChange={handleToDateChange}
                                                                    format="dd/MM/yyyy"
                                                                    dayPlaceholder="DD"
                                                                    monthPlaceholder="MM"
                                                                    yearPlaceholder="YYYY"
                                                                    className="custom-date-picker"
                                                                />

                                                                {error && !bookingFormData.pujaStartDate && (
                                                                    <span className="error-msg">{t(ERROR_MESSAGES)}</span>
                                                                )}
                                                            </div>



                                                            {/* Select Language */}
                                                            <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size">
                                                                <label htmlFor="language" style={{ textAlign: "left" }}>
                                                                    {t("Select Language")}<span style={{ color: "red" }}>*</span>
                                                                </label>
                                                                <Select

                                                                    options={languageOption}
                                                                    onChange={handleLanguageChange}
                                                                    value={languageOption.find(
                                                                        (item) => item.value === bookingFormData.languageID
                                                                    )}
                                                                    styles={customSelectStyles}
                                                                />

                                                                {error && !bookingFormData.languageID && (
                                                                    <span className="error-msg">{t(ERROR_MESSAGES)}</span>
                                                                )}
                                                            </div>

                                                            {/* Address */}
                                                            <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size">
                                                                <label htmlFor="address" style={{ textAlign: "left" }}>
                                                                    {t("Address")}<span style={{ color: "red" }}>*</span>
                                                                </label>
                                                                <textarea
                                                                    id="address"
                                                                    className="custom-form-control"
                                                                    value={bookingFormData.address || ""}
                                                                    onChange={(e) => {
                                                                        let inputVal = e.target.value.trimStart();
                                                                        setBookingData((prev) => ({
                                                                            ...prev,
                                                                            address: inputVal,
                                                                        }));
                                                                    }}
                                                                    placeholder={t("Enter Address")}
                                                                />
                                                                {error && !bookingFormData.address && (
                                                                    <span className="error-msg">{t(ERROR_MESSAGES)}</span>
                                                                )}
                                                            </div>
                                                        </>
                                                    )}


                                                </>
                                            ) : ''}


                                            {/* --------------------------Daily Pandit Puja--------------------------- */}
                                            {pujaDetails?.pujaSubServiceID === 6 && (
                                                <>
                                                    {/* Booking Data */}
                                                    <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size" >
                                                        <label
                                                            htmlFor="bookingDateStart"
                                                            style={{ textAlign: "left" }}
                                                        >
                                                            {t("Puja Start Date")}<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <DatePicker
                                                            id="bookingDateStart"
                                                            value={bookingFormData?.pujaStartDate || ""}
                                                            minDate={
                                                                new Date(new Date().setDate(new Date().getDate() + 3))
                                                            }
                                                            clearIcon={null}
                                                            onChange={handleStartDateChange}
                                                            format="dd/MM/yyyy"
                                                            className="custom-date-picker"
                                                            dayPlaceholder="DD"
                                                            monthPlaceholder="MM"
                                                            yearPlaceholder="YYYY"
                                                        />

                                                        {error && !bookingFormData.pujaStartDate && (
                                                            <span style={{ color: "red" }}>{t(ERROR_MESSAGES)}</span>
                                                        )}
                                                    </div>

                                                    {/* Duration */}
                                                    <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size" >
                                                        <label htmlFor="duration" style={{ textAlign: "left" }}>
                                                            {t("Select Duration")}<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <Select
                                                            styles={customSelectStyles}
                                                            options={durationList}
                                                            onChange={handleDurationChange}
                                                            value={durationList.find(
                                                                (item) => item.value === bookingFormData?.durationID
                                                            )}
                                                        />
                                                        {error && !bookingFormData?.durationID && (
                                                            <span style={{ color: "red" }}>{t(ERROR_MESSAGES)}</span>
                                                        )}
                                                    </div>

                                                    {/* Select Days */}
                                                    <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size" >
                                                        <label htmlFor="language" style={{ textAlign: "left" }}>
                                                            {t("Select Days")}<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <Select
                                                            styles={customSelectStyles}
                                                            options={daysList}
                                                            onChange={handleDaysChange}
                                                            value={daysList.find(
                                                                (item) => item.value === selectedDays
                                                            )}
                                                        />
                                                        {error && !selectedDays && (
                                                            <span style={{ color: "red" }}>{t(ERROR_MESSAGES)}</span>
                                                        )}
                                                    </div>

                                                    {/* Puja End Date */}
                                                    {/* <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size" >
                                                        <label
                                                            htmlFor="bookingDateEnd"
                                                            style={{ textAlign: "left" }}
                                                        >
                                                            {t("Puja End Date")}<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <DatePicker
                                                            id="bookingDateEnd"
                                                            disabled
                                                            value={bookingFormData?.pujaEndDate || ""}
                                                            minDate={
                                                                new Date(new Date().setDate(new Date().getDate() + 3))
                                                            }
                                                            clearIcon={null}
                                                            // onChange={handleEndDateChange}
                                                            format="dd/MM/yyyy"
                                                            className="custom-date-picker"

                                                        />

                                                        {error && !bookingFormData.pujaEndDate && (
                                                            <span style={{ color: "red" }}>{t(ERROR_MESSAGES)}</span>
                                                        )}

                                                    </div> */}

                                                    {/* Puja Time */}
                                                    <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size">
                                                        <label style={{ textAlign: "left" }}>
                                                            {t("Puja Start Time")}<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <input
                                                            id="bookingTime"
                                                            type="time"
                                                            className="custom-form-control"
                                                            value={bookingFormData.pujaStartTime || ""}
                                                            onClick={(e) => e.target.showPicker && e.target.showPicker()}
                                                            onChange={(e) => {
                                                                const [hour, minute] = e.target.value.split(":");
                                                                let hr = parseInt(hour, 10);
                                                                const ampm = hr >= 12 ? "PM" : "AM";
                                                                hr = hr % 12 || 12;
                                                                const formattedTime = `${hr}:${minute} ${ampm}`;

                                                                setBookingData((prev) => ({
                                                                    ...prev,
                                                                    pujaStartTime: e.target.value,

                                                                }));
                                                            }}
                                                        />
                                                        {error && !bookingFormData.pujaStartTime && (
                                                            <span className="error-msg">{t(ERROR_MESSAGES)}</span>
                                                        )}
                                                    </div>

                                                    {/* Puja Time */}
                                                    {/* <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size">
                                                        <label style={{ textAlign: "left" }}>
                                                            {t("Puja End Time")}<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <input
                                                            id="bookingEndTime"
                                                            type="time"
                                                            className="custom-form-control"
                                                            value={bookingFormData.pujaEndTime || ""}
                                                            onClick={(e) => e.target.showPicker && e.target.showPicker()}
                                                            onChange={(e) => {
                                                                const [hour, minute] = e.target.value.split(":");
                                                                let hr = parseInt(hour, 10);
                                                                const ampm = hr >= 12 ? "PM" : "AM";
                                                                hr = hr % 12 || 12;
                                                                const formattedTime = `${hr}:${minute} ${ampm}`;

                                                                setBookingData((prev) => ({
                                                                    ...prev,
                                                                    pujaEndTime: e.target.value,

                                                                }));
                                                            }}
                                                        />
                                                        {error && !bookingFormData.pujaEndTime && (
                                                            <span className="error-msg">{t(ERROR_MESSAGES)}</span>
                                                        )}
                                                    </div> */}

                                                    {/* Select Language */}
                                                    <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size">
                                                        <label htmlFor="language" style={{ textAlign: "left" }}>
                                                            {t("Select Language")}<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <Select

                                                            options={languageOption}
                                                            onChange={handleLanguageChange}
                                                            value={languageOption.find(
                                                                (item) => item.value === bookingFormData.languageID
                                                            )}
                                                            styles={customSelectStyles}
                                                        />

                                                        {error && !bookingFormData.languageID && (
                                                            <span className="error-msg">{t(ERROR_MESSAGES)}</span>
                                                        )}
                                                    </div>

                                                    {/* State */}
                                                    <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size">
                                                        <label htmlFor="state" style={{ textAlign: "left" }}>
                                                            {t("State")}<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <Select

                                                            options={stateLookupList}
                                                            value={stateLookupList.find(
                                                                (item) => item.value === bookingFormData.stateID
                                                            )}
                                                            onChange={(selectedOption) => {
                                                                setBookingData((prev) => ({
                                                                    ...prev,
                                                                    stateID: selectedOption?.value,
                                                                }));
                                                                GetDistrictLookupListData(selectedOption?.value)
                                                            }}
                                                            styles={customSelectStyles}
                                                        />
                                                        {error && !bookingFormData.stateID && (
                                                            <span className="error-msg">{t(ERROR_MESSAGES)}</span>
                                                        )}
                                                    </div>

                                                    {/* City */}
                                                    <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size">
                                                        <label htmlFor="City" style={{ textAlign: "left" }}>
                                                            {t("City")}<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <Select

                                                            options={cityLookupList}
                                                            value={cityLookupList.find(
                                                                (item) => item.value === bookingFormData.districtID
                                                            )}
                                                            onChange={(selectedOption) => {
                                                                setBookingData((prev) => ({
                                                                    ...prev,
                                                                    districtID: selectedOption?.value,
                                                                }));
                                                            }}
                                                            styles={customSelectStyles}
                                                        />
                                                        {error && !bookingFormData.districtID && (
                                                            <span className="error-msg">{t(ERROR_MESSAGES)}</span>
                                                        )}
                                                    </div>{" "}




                                                    {/* Address */}
                                                    <div className="col-md-6 col-sm-12 mb-2 d-flex flex-column form-font-size">
                                                        <label htmlFor="address" style={{ textAlign: "left" }}>
                                                            {t("Address")}<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <textarea
                                                            id="address"
                                                            className="custom-form-control"
                                                            value={bookingFormData.address || ""}
                                                            onChange={(e) => {
                                                                let inputVal = e.target.value.trimStart();
                                                                setBookingData((prev) => ({
                                                                    ...prev,
                                                                    address: inputVal,
                                                                }));
                                                            }}
                                                            placeholder={t("Enter Address")}
                                                        />
                                                        {error && !bookingFormData.address && (
                                                            <span className="error-msg">{t(ERROR_MESSAGES)}</span>
                                                        )}
                                                    </div>



                                                </>
                                            )}

                                            {/* Puja Samgri */}
                                            {/* {((pujaDetails?.pujaSubServiceID === 5 || pujaDetails?.pujaSubServiceID === 6) && pujaDetails?.pujaTypeID !== 1) && (
                                                <> */}
                                            {/* {Number(pujaDetails?.wetSamagriPrice) > 0 && (
                                                <div className='form-font-size'>
                                                    {t("Do you want Samagri for this Puja")}?
                                                </div>
                                            )} */}

                                            <div className="row mb-3 " style={{ justifyContent: 'left' }}>
                                                {/* Fresh Samagri */}
                                                {/* {Number(pujaDetails?.wetSamagriPrice) > 0 && (
                                                    <div className="col-md-6 col-sm-12 d-flex align-items-center">
                                                        <label className="fw-semibold me-2 mb-0 form-font-size">{t("Fresh Samagri")}:</label>
                                                        <div className="d-flex align-items-center">
                                                            <label className="me-3 mb-0 form-font-size">
                                                                <input
                                                                    type="radio"
                                                                    name="wetSamagri"

                                                                    checked={bookingFormData.isWetSamagriNeeded}
                                                                    onChange={(e) =>
                                                                        setBookingData((prev) => ({
                                                                            ...prev,
                                                                            isWetSamagriNeeded: true,
                                                                        }))
                                                                    }
                                                                    className="me-1"
                                                                />
                                                                {t("Yes")}
                                                            </label>
                                                            <label className="mb-0 form-font-size ">
                                                                <input
                                                                    type="radio"
                                                                    name="wetSamagri"

                                                                    checked={bookingFormData.isWetSamagriNeeded === false}
                                                                    onChange={(e) =>
                                                                        setBookingData((prev) => ({
                                                                            ...prev,
                                                                            isWetSamagriNeeded: false,
                                                                        }))
                                                                    }
                                                                    className="me-1"
                                                                />
                                                                {t("No")}
                                                            </label>
                                                        </div>
                                                    </div>
                                                )} */}
                                                {/* Dry Samagri */}
                                                {/* {Number(pujaDetails?.drySamagriPrice) > 0 && (
                                                            <div className="col-md-6 col-sm-12 d-flex align-items-center">
                                                                <label className="fw-semibold me-2 mb-0 form-font-size">{t("Dry Samagri")}:</label>
                                                                <div className="d-flex align-items-center">
                                                                    <label className="me-3 mb-0 form-font-size">
                                                                        <input
                                                                            type="radio"
                                                                            name="drySamagri"

                                                                            checked={bookingFormData?.isDrySamagriNeeded}
                                                                            onChange={(e) =>
                                                                                setBookingData((prev) => ({
                                                                                    ...prev,

                                                                                    isDrySamagriNeeded: true,
                                                                                }))
                                                                            }
                                                                            className="me-1"
                                                                        />
                                                                        {t("Yes")}
                                                                    </label>
                                                                    <label className="mb-0 form-font-size">
                                                                        <input
                                                                            type="radio"
                                                                            name="drySamagri"

                                                                            checked={bookingFormData.isDrySamagriNeeded === false}
                                                                            onChange={(e) =>
                                                                                setBookingData((prev) => ({
                                                                                    ...prev,
                                                                                    isDrySamagriNeeded: false,

                                                                                }))
                                                                            }
                                                                            className="me-1"
                                                                        />
                                                                        {t("No")}
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        )} */}


                                            </div>

                                            {/* Price Message Centered */}
                                            {
                                                // (Number(pujaDetails?.wetSamagriPrice) > 0 || Number(pujaDetails?.drySamagriPrice) > 0) && (
                                                //     <div className="row">
                                                //         <div className="col-12 d-flex justify-content-center">
                                                //             <div
                                                //                 style={{
                                                //                     background: "linear-gradient(90deg, #eeb11a, #a52444)",
                                                //                     padding: "5px 15px",
                                                //                     borderRadius: "8px",
                                                //                     fontWeight: "bold",
                                                //                     textAlign: "center",
                                                //                     color: "white",
                                                //                     minWidth: "320px",
                                                //                     fontSize: '16px'
                                                //                 }}
                                                //             >
                                                //                 {
                                                //                     bookingFormData?.isWetSamagriNeeded === true &&
                                                //                         bookingFormData?.isDrySamagriNeeded === true ? (
                                                //                         <>
                                                //                             {t("Samagri Amount")}: ₹{" "}
                                                //                             {formatToIndianCurrency(
                                                //                                 (Number(pujaDetails?.drySamagriPrice || 0) +
                                                //                                     Number(pujaDetails?.wetSamagriPrice || 0))
                                                //                             )}
                                                //                         </>
                                                //                     ) :
                                                //                     bookingFormData?.isWetSamagriNeeded === true ? (
                                                //                         <>
                                                //                             {t("Fresh Samagri Amount")}: ₹{" "}
                                                //                             {formatToIndianCurrency(pujaDetails?.wetSamagriPrice || 0)}
                                                //                         </>
                                                //                     ) :
                                                //                         bookingFormData?.isDrySamagriNeeded === true ? (
                                                //                             <>
                                                //                                 {t("Dry Samagri Amount")}: ₹{" "}
                                                //                                 {formatToIndianCurrency(pujaDetails?.drySamagriPrice || 0)}
                                                //                             </>
                                                //                         ) : 
                                                //                         (
                                                //                             <>{t("Fresh samagri will be arranged by you.")}  </>
                                                //                         )}

                                                //             </div>
                                                //         </div>
                                                //     </div>
                                                // )
                                            }


                                            {/* </>
                                            )} */}
                                        </div>
                                    </fieldset>
                                </div>

                                {/* Right Side - Price Summary */}

                                <div className="col-md-4 col-sm-12 mb-3">
                                    <fieldset className="border rounded p-3">
                                        <legend className="float-none w-auto px-2 fw-bold" style={{ fontSize: "14px" }}>
                                            {t("Payment Summary")}
                                        </legend>
                                        <div className='border rounded p-2 mb-2'>
                                            <ul className="list-unstyled mb-0">
                                                <li className="d-flex justify-content-between">
                                                    <span className=" payment-form-field">
                                                        {t("Puja Price")} (₹):


                                                    </span>
                                                    <span className="payment-form-field">
                                                        {formatToIndianCurrency(Math.round(pujaPriceWithAllCharges))}
                                                    </span>

                                                </li>
                                                <li style={{ fontSize: "11px", color: "#666", marginTop: "4px" }}>
                                                    {t("Note : Convenience fee and All Samagri are included in the total Puja cost.")}
                                                </li>
                                                {isWalletApplied || isCouponApplied ? <hr /> : ''}


                                                {isWalletApplied && isCouponApplied === false ? (
                                                    <>


                                                        <li className="d-flex justify-content-between">
                                                            <span className=" payment-form-field">
                                                                {t("Applied Wallet Amount")} (₹)

                                                            </span>
                                                            <span className=" payment-form-field">
                                                                {appliedCoupon?.walletAmount}
                                                            </span>
                                                        </li>
                                                    </>
                                                ) : isWalletApplied === false && isCouponApplied ? (
                                                    <li className="d-flex justify-content-between">
                                                        <span className=" payment-form-field">
                                                            {t("Applied Coupon Amount")} (₹)
                                                        </span>
                                                        <span className=" payment-form-field">
                                                            {formatToIndianCurrency(couponAmount)}
                                                        </span>
                                                    </li>
                                                ) : ''}
                                                <hr />

                                                {/* {pujaDetails?.pujaCategoryName !== "Deepdan" && (
                                                    <>
                                                        {
                                                            (bookingFormData?.isWetSamagriNeeded && bookingFormData?.isDrySamagriNeeded)
                                                                ?
                                                                (
                                                                    <>
                                                                        <li className="d-flex justify-content-between">
                                                                            <span className=" payment-form-field">{t("Samagri Price")} (₹):</span>
                                                                            <span className=" payment-form-field">
                                                                                {pujaDetails?.pujaSubServiceID === 6 ? (
                                                                                    formatToIndianCurrency(((Number(pujaDetails?.wetSamagriPrice) +
                                                                                        Number(pujaDetails?.wetSamagriPriceTaxAmount)) + (Number(pujaDetails?.drySamagriPrice) +
                                                                                            Number(pujaDetails?.drySamagriPriceTaxAmount))) * bookingFormData?.days)
                                                                                ) : (
                                                                                    formatToIndianCurrency(((Number(pujaDetails?.wetSamagriPrice) +
                                                                                        Number(pujaDetails?.wetSamagriPriceTaxAmount)) + (Number(pujaDetails?.drySamagriPrice) +
                                                                                            Number(pujaDetails?.drySamagriPriceTaxAmount))))
                                                                                )}



                                                                            </span>
                                                                        </li>
                                                                        <hr></hr>
                                                                    </>
                                                                )
                                                                :
                                                            (bookingFormData?.isWetSamagriNeeded)
                                                                ?
                                                                (
                                                                    <>
                                                                        <li className="d-flex justify-content-between">
                                                                            <span className=" payment-form-field"> {t("Fresh Samagri Price")} (₹):</span>
                                                                            <span className=" payment-form-field">
                                                                                {pujaDetails?.pujaSubServiceID === 6 ? (
                                                                                    formatToIndianCurrency(
                                                                                        ((Number(pujaDetails?.wetSamagriPrice) +
                                                                                            Number(pujaDetails?.wetSamagriPriceTaxAmount)) * bookingFormData?.days)

                                                                                    )) : (
                                                                                    formatToIndianCurrency(
                                                                                        ((Number(pujaDetails?.wetSamagriPrice) +
                                                                                            Number(pujaDetails?.wetSamagriPriceTaxAmount)))
                                                                                    ))}


                                                                            </span>
                                                                        </li>
                                                                        <hr></hr>
                                                                    </>
                                                                ) :
                                                                 (bookingFormData?.isWetSamagriNeeded === false && bookingFormData?.isDrySamagriNeeded)
                                                                    ?
                                                                    (
                                                                        <>
                                                                            <li className="d-flex justify-content-between">
                                                                                <span className=" payment-form-field"> {t("Dry Samagri Price")} (₹):</span>
                                                                                <span className=" payment-form-field">
                                                                                    {pujaDetails?.pujaSubServiceID === 6 ? (
                                                                                        formatToIndianCurrency(
                                                                                            ((Number(pujaDetails?.drySamagriPrice) +
                                                                                                Number(pujaDetails?.drySamagriPriceTaxAmount)) * bookingFormData?.days)
                                                                                        )
                                                                                    ) : (
                                                                                        formatToIndianCurrency(
                                                                                            ((Number(pujaDetails?.drySamagriPrice) +
                                                                                                Number(pujaDetails?.drySamagriPriceTaxAmount)))
                                                                                        )
                                                                                    )}


                                                                                    { }

                                                                                </span>
                                                                            </li>
                                                                            <hr></hr>
                                                                        </>
                                                                    ) : 
                                                                ''
                                                        }

                                                    </>
                                                )} */}
                                                {/* {(pujaDetails?.convenienceFee !== undefined &&
                                                    pujaDetails?.convenienceFee !== null &&
                                                    Number(pujaDetails?.convenienceFee) !== 0) && (
                                                        <>
                                                            <li className="d-flex justify-content-between">
                                                                <span className=" payment-form-field">
                                                                    {t("Convenience Fee")} (₹):
                                                                </span>
                                                                <span className=" payment-form-field">
                                                                    {pujaDetails?.pujaSubServiceID === 6 ? (
                                                                        formatToIndianCurrency(Math.round(Math.round(Math.round(Number(pujaDetails?.convenienceFee)) +
                                                                            Math.round(Number(pujaDetails?.convinienceFeeTaxAmount) || 0))) * (bookingFormData?.days || 1))
                                                                    ) : (
                                                                        formatToIndianCurrency(Math.round(pujaDetails?.convenienceFee) +
                                                                            (Math.round(pujaDetails?.convinienceFeeTaxAmount) || 0))
                                                                    )}



                                                                </span>
                                                            </li>
                                                            <hr />
                                                        </>
                                                    )} */}

                                                <li className="d-flex justify-content-between fw-bold">
                                                    <span className="payment-form-field">{t("Grand Total")} (₹):</span>
                                                    <span className="payment-form-field">
                                                        {formatToIndianCurrency(Math.round(grandTotal))}
                                                    </span>
                                                </li>
                                            </ul>
                                        </div>

                                        <div className='border rounded p-2 mb-2'>
                                            {/* Wallet */}
                                            {availableWalletAmount !== 0 && (
                                                <>
                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                        <div className="d-flex align-items-center">
                                                            <i className="bi bi-wallet2 fs-5 me-2 text-primary-custom"></i>
                                                            <div style={{ lineHeight: "1.2" }}>
                                                                <strong className="small" style={{ fontWeight: "600", color: "grey" }}>{t("Use Wallet Balance")}</strong><br />
                                                                <small className="text-muted">{t("Available")}: ₹ {isWalletApplied ? availableWalletAmount - appliedCoupon?.walletAmount : availableWalletAmount}</small>
                                                            </div>
                                                        </div>
                                                        {isWalletApplied ? (
                                                            <button className="btn btn-outline-primary btn-sm py-0 px-2" onClick={(e) => {

                                                                setIsWalletApplied(!isWalletApplied)
                                                            }
                                                            }>{t("Remove Wallet")}</button>
                                                        ) : (
                                                            <button className="btn btn-outline-primary btn-sm py-0 px-2" onClick={(e) => {
                                                                setAppliedCoupon((PREV) => ({
                                                                    ...PREV, couponCode: null,
                                                                    isApplied: false
                                                                }))
                                                                setIsWalletApplied(!isWalletApplied)
                                                                setIsCouponApplied(false)
                                                            }
                                                            }>{t("Apply Wallet")}</button>
                                                        )}

                                                    </div>
                                                    <div className="d-flex align-items-center mb-2" style={{ fontSize: "13px" }}>
                                                        <hr className="flex-grow-1 my-1" />
                                                        <span className="px-2 text-muted">{t("or")}</span>
                                                        <hr className="flex-grow-1 my-1" />
                                                    </div>
                                                </>

                                            )}


                                            {/* Coupons */}
                                            {isCouponApplied ? (
                                                <div

                                                    style={{

                                                        borderRadius: '10px',
                                                        padding: '10px',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'space-between',
                                                        cursor: 'pointer',

                                                        color: '#000',
                                                        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                                        width: '100%'
                                                    }}
                                                >
                                                    <div onClick={() => handleOpenCoupenModal()} style={{ display: 'flex', alignItems: 'center' }}>

                                                        <span className=" payment-form-field">{t("Applied Coupon Code")}</span>
                                                        {appliedCoupon && (
                                                            <>
                                                                <span
                                                                    style={{
                                                                        border: '1px dotted #333',
                                                                        padding: '2px 6px',
                                                                        borderRadius: '4px',
                                                                        fontSize: '12px',
                                                                        backgroundColor: '#fff',
                                                                        color: '#333',
                                                                        marginLeft: '6px',
                                                                    }}
                                                                >
                                                                    {appliedCoupon?.couponCode}
                                                                </span>

                                                            </>


                                                        )}
                                                    </div>
                                                    <span
                                                        onClick={() => {
                                                            setAppliedCoupon((prev) => ({
                                                                ...prev, couponCode: null,
                                                                isApplied: false,
                                                                couponAmount: 0,
                                                                walletAmount: 0
                                                            }))
                                                            setIsCouponApplied(false)
                                                            setCouponCodeInput("")
                                                        }}
                                                        style={{

                                                            padding: '2px 6px',
                                                            borderRadius: '4px',
                                                            fontSize: '12px',
                                                            backgroundColor: '#fff',
                                                            color: '#a52444',
                                                            marginLeft: '6px',
                                                        }} >



                                                        {t("Remove")}

                                                    </span>
                                                    <span style={{ fontSize: '20px', fontWeight: 'lighter' }}>›</span>
                                                </div>
                                            ) : (
                                                <div className="mb-2">
                                                    {/* Input + Apply */}
                                                    <div className="d-flex gap-2">
                                                        <input
                                                            type="text"
                                                            className="custom-form-control"
                                                            placeholder={t("Enter Coupon Code")}
                                                            value={couponCodeInput}
                                                            onChange={(e) => {
                                                                setCouponCodeInput(e.target.value);
                                                                if (couponMessageVisible) {
                                                                    setCouponMessage("");
                                                                    setCouponMessageVisible(false);
                                                                }
                                                            }}
                                                        />

                                                        <button
                                                            type="button"
                                                            style={{ padding: "5px 16px", fontSize: "14px" }}
                                                            className="Normal-app-btn"
                                                            disabled={!couponCodeInput.trim() || isApplying}
                                                            onClick={async () => {
                                                                const orderAmount =
                                                                    bookingFormData?.pujaType === 1
                                                                        ? Math.round(
                                                                            pujaDetails.onlinePujaPrice -
                                                                            (pujaDetails.onlinePujaDiscountAmount || 0)
                                                                        )
                                                                        : Math.round(
                                                                            pujaDetails.offlinePujaPrice -
                                                                            (pujaDetails.offlinePujaDiscountAmount || 0)
                                                                        );

                                                                const updatedCouponObj = {
                                                                    ...couponObj,
                                                                    pujaServiceID: pujaDetails?.pujaServiceID,
                                                                    pujaSubServiceID: pujaDetails?.pujaSubServiceID,
                                                                    orderAmount: orderAmount,
                                                                };

                                                                // Update state for later use
                                                                setCouponObj(updatedCouponObj);

                                                                setModelRequestData((prev) => ({ ...prev, moduleName: 'PujaBooking' }))
                                                                setCouponMessage("");
                                                                setCouponMessageVisible(false);


                                                                const result = await applyCoupon(couponCodeInput, updatedCouponObj);

                                                                if (result.success) {
                                                                    setCouponMessage("");
                                                                    setCouponMessageVisible(false);
                                                                } else {
                                                                    setCouponMessage(result.message);
                                                                    setCouponMessageVisible(true);
                                                                }
                                                            }}
                                                        >
                                                            {isApplying ? t("Applying...") : t("Apply")}
                                                        </button>
                                                    </div>

                                                    {/* Coupon validation message */}
                                                    {couponMessageVisible && couponMessage && (
                                                        <div
                                                            style={{
                                                                color: "#dc3545",
                                                                fontSize: "12px",
                                                                marginTop: "5px",
                                                                paddingLeft: "2px",
                                                            }}
                                                        >
                                                            {couponMessage}
                                                        </div>
                                                    )}
                                                </div>
                                            )}
                                            {/* <div className="input-group input-group-sm mb-2 ">

                                                {isCouponApplied ? (
                                                    <div

                                                        style={{

                                                            borderRadius: '10px',
                                                            padding: '10px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',
                                                            cursor: 'pointer',
                                                            
                                                            color: '#000',
                                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                                            width: '100%'
                                                        }}
                                                    >
                                                        <div onClick={() => handleOpenCoupenModal()} style={{ display: 'flex', alignItems: 'center' }}>

                                                            <span className=" payment-form-field">{t("Applied Coupon Code")}</span>
                                                            {appliedCoupon && (
                                                                <>
                                                                    <span
                                                                        style={{
                                                                            border: '1px dotted #333',
                                                                            padding: '2px 6px',
                                                                            borderRadius: '4px',
                                                                            fontSize: '12px',
                                                                            backgroundColor: '#fff',
                                                                            color: '#333',
                                                                            marginLeft: '6px',
                                                                        }}
                                                                    >
                                                                        {appliedCoupon?.couponCode}
                                                                    </span>

                                                                </>


                                                            )}
                                                        </div>
                                                        <span
                                                            onClick={() => {
                                                                setAppliedCoupon((prev) => ({
                                                                    ...prev, couponCode: null,
                                                                    isApplied: false,
                                                                    couponAmount: 0,
                                                                    walletAmount: 0
                                                                }))
                                                                setIsCouponApplied(false)
                                                            }}
                                                            style={{
                                                                
                                                                padding: '2px 6px',
                                                                borderRadius: '4px',
                                                                fontSize: '12px',
                                                                backgroundColor: '#fff',
                                                                color: '#a52444',
                                                                marginLeft: '6px',
                                                            }} >



                                                            Remove

                                                        </span>
                                                        <span style={{ fontSize: '20px', fontWeight: 'lighter' }}>›</span>
                                                    </div>
                                                ) : (
                                                    <div className='border border-1'
                                                        onClick={() => handleOpenCoupenModal()}
                                                        style={{

                                                            borderRadius: '10px',
                                                            padding: '10px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',
                                                            cursor: 'pointer',
                                                            
                                                            color: '#000',
                                                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                                            width: '100%'
                                                        }}
                                                    >
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            <div style={{
                                                                backgroundColor: '#a52444',
                                                                color: 'white',
                                                                borderRadius: '50%',
                                                                width: '24px',
                                                                height: '24px',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center',
                                                                fontSize: '14px',
                                                                marginRight: '10px',

                                                            }}>
                                                                %
                                                            </div>
                                                            <span style={{ fontWeight: '400' }}>{t("View Coupons & Offers")}</span>

                                                        </div>

                                                    </div>
                                                )}

                                            </div> */}
                                            {/* <hr className="flex-grow-1 my-3" /> */}
                                        </div>




                                        <div className='text-left '>
                                            {((pujaDetails?.pujaSubServiceID === 6 || pujaDetails?.pujaSubServiceID === 5) && (pujaDetails?.pujaCategoryName !== "Deepdan")) && (
                                                (pujaDetails?.paymentTypeID === PaymentTypeID?.COD || pujaDetails?.paymentTypeID === PaymentTypeID?.Both) && (

                                                    <button
                                                        style={{ padding: "5px 5px", fontSize: "14px" }}
                                                        className="Normal-app-btn mx-2"
                                                        onClick={handleCODClicked}

                                                    >
                                                        {t("Cash On Delivery")}
                                                    </button>
                                                )
                                            )}
                                            {(pujaDetails?.paymentTypeID === PaymentTypeID?.Online || pujaDetails?.paymentTypeID === PaymentTypeID?.Both) && (

                                                <button
                                                    style={{ padding: "5px 16px", fontSize: "14px" }}
                                                    className="Normal-app-btn"
                                                    onClick={handleRazorpayPayment}
                                                >
                                                    {t("Pay Now")}
                                                </button>
                                            )}
                                        </div>
                                    </fieldset>
                                    {/* Payment buttons  */}






                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
            <CouponModal
                show={showCouponModal}
                handleClose={() => setShowCouponsModal(false)}
                modelRequestData={modelRequestData}
                setAppliedCoupon={setAppliedCoupon}
                setIsWalletApplied={setIsWalletApplied}
                setIsCouponApplied={setIsCouponApplied}
                apiParam={couponObj} />
            <CODModal
                show={showCODModal}
                onHide={() => setShowCODModal(false)}
                onConfirm={handleRazorpayPayment}
                modelRequestData={modelRequestData}
                setModelRequestData={setModelRequestData}
            />
        </>
    )
}

export default PujaBookingFormSection
